import { isNil } from 'lodash';
import { apiDataResponseMapper } from '../utils';
import {
  type Organisation,
  type OrganisationResponseData,
  type OrganisationSettings,
  type OrganisationSettingsResponseData,
} from './type';

export const organisationResponseMapper = (
  responseData: OrganisationResponseData,
): Organisation => {
  const mappedData: Organisation = {
    name: responseData.name,
    logo: responseData.logo,
    featureFlags: responseData.feature_flags,
  };

  if (!isNil(responseData.settings)) {
    mappedData.settings = apiDataResponseMapper<
      OrganisationSettingsResponseData,
      OrganisationSettings
    >(responseData.settings);
  }

  if (!isNil(responseData.grace_period_for_2fa)) {
    mappedData.gracePeriodFor2FA = responseData.grace_period_for_2fa;
  }

  return mappedData;
};
